module.exports = __webpack_public_path__ + "static/media/facebookbannertablet.fd787585.png";